import React from 'react';
import WrappedModal from 'components/modal/WrappedModal';
import { useTranslation } from 'react-i18next';
import { Button, Form, Modal } from 'semantic';
import { Formik, FormikState } from 'formik';
import { SessionThresholds } from 'screens/GroupsAndPolicies/types';
import { sessionThresholdsSchema } from 'screens/GroupsAndPolicies/validation';
import { SessionThresholdsFormFields } from 'screens/GroupsAndPolicies/ChargingPolicy/SessionThresholdsFormFields';

type Props = {
  trigger: React.ReactNode;
  onSubmit: (values: SessionThresholds) => void;
  currency: string;
  values?: FormikState<SessionThresholds>['values'];
};

export function SessionThresholdsModal({
  trigger,
  onSubmit,
  currency,
  values,
}: Props) {
  const [isOpen, setIsOpen] = React.useState(true);

  const { t } = useTranslation();

  return (
    <WrappedModal isOpen={isOpen} setIsOpen={setIsOpen} trigger={trigger}>
      <Formik
        initialValues={values || ({} as SessionThresholds)}
        validationSchema={sessionThresholdsSchema}
        onSubmit={(values) => {
          setIsOpen(false);
          onSubmit(values);
        }}
        onReset={() => setIsOpen(false)}>
        {({ handleSubmit, handleReset, values }) => (
          <>
            <Modal.Header>
              {t(
                'sessionThresholds.editSessionThresholdsTitle',
                'Session Thresholds'
              )}
            </Modal.Header>
            <Modal.Content>
              <Form>
                <SessionThresholdsFormFields
                  values={values}
                  currency={currency}
                />
              </Form>
            </Modal.Content>
            <Modal.Actions>
              <Button
                content={t(
                  'sessionThresholds.editButton',
                  'Update and back to policy'
                )}
                as="button"
                style={{ marginLeft: '0' }} // TODO: look for better solution
                onClick={handleSubmit}
              />
              <Button
                content={t('sessionThresholds.cancelButton', 'Cancel')}
                as="button"
                basic
                onClick={handleReset}
              />
            </Modal.Actions>
          </>
        )}
      </Formik>
    </WrappedModal>
  );
}
